/**
 * Module to handle first & last arrows disappearing if we reach first or last slide. It will track index
 * Does not to be applied to a loop carousels
 *
 * Usage:
 *
 *  var $carousel = $('.my-page-specific-carousel');
 *  var toggleArrowsVisibility = require('src/interlock/ui/owl-carousel/toggle-arrows-visibility');
 *  $carousel.on('changed.owl.carousel', function (event) {
 *      toggleArrowsVisibility($carousel, event.item.index, event.item.count);
 *  });
 */

/**
 * Shortcut for jquery toggleClass with class name predefined
 *
 * @param $target
 * @param flag
 * @return {undefined}
 */
function toggleInvisible($target, flag) {
    $target.toggleClass('invisible', flag);
}

/**
 * Get arrow element controls
 *
 * @param $carousel
 * @return {*}
 */
function getArrows($carousel) {
    return $carousel.siblings('.carousel-control');
}

/**
 * Hide/show arrows depending on current index and item count in carousel
 *
 * @param $carousel
 * @param index
 * @param lastIndex
 */
module.exports = function toggleArrowsVisibility($carousel, index, lastIndex) {
    var isFirstIndex = index === 0,
        isLastIndex = index === lastIndex,

        $arrows = getArrows($carousel),

        $leftArrow = $arrows.siblings('.left'),

        $rightArrow = $arrows.siblings('.right');

    toggleInvisible($leftArrow, isFirstIndex);
    toggleInvisible($rightArrow, isLastIndex);
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/ui/owl-carousel/toggle-arrows-visibility.js
// module id = 18
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 12 13 14 15 17